import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { NuovoPagamentoService } from '../../services/nuovo-pagamento.service';
import { FiltroServizio } from 'src/app/modules/main/model/FiltroServizio';
import { DatiPagamento } from 'src/app/features/pagamenti/model/DatiPagamento';
import { Breadcrumb } from 'src/app/modules/main/dto/Breadcrumb';

@Component({
  selector: 'app-nuovo-pagamento',
  templateUrl: './nuovo-pagamento.component.html',
  styleUrls: ['./nuovo-pagamento.component.scss']
})
export class NuovoPagamentoComponent implements OnInit {
  servizioSelezionato: FiltroServizio;
  breadcrumbList = [];
  titolo: string;

  @Input()
  datiPagamento: DatiPagamento;

  @Input()
  filtroPagamento = true;

  servizioId: number;

  idServizioDiretto: string;


  constructor(private route: ActivatedRoute, private nuovoPagamentoService: NuovoPagamentoService, private router: Router) {
    this.nuovoPagamentoService.compilazioneEvent.subscribe(servizioSelezionato => {
      this.servizioSelezionato = servizioSelezionato;
    });
    this.route.queryParams.subscribe((params) => {
      this.servizioId = parseInt(params.servizio);
    });
    if (this.route.snapshot.paramMap.get('idServizioDiretto')!=null){
      // recupero parametro dall'URL
      this.idServizioDiretto = this.route.snapshot.paramMap.get('idServizioDiretto');
      // controllo se il parametro è numerico
      if (!isNaN(+this.idServizioDiretto)){
        // QUI DEVO CHIAMARE IL BE PER CARICARMI I DATI DI QUELL'ID
        this.servizioId = +this.idServizioDiretto;
        // this.nuovoPagamentoService.getDatiServizioDiretto(
        //   +this.idServizioDiretto
        // ).subscribe((triade: Triade) => {
        //   this.servizioId = triade.servizio.id;
        //   console.log(this.servizioId);
        // });
      } else {
        this.router.navigate(["nuovoPagamento"]);
      }
    };
  }

  ngOnInit(): void {
    this.inizializzaHeaderSezione();
  }

  inizializzaHeaderSezione(): void {
    if (this.datiPagamento) {
      this.titolo = 'Dettaglio pagamento';
      this.breadcrumbList.push(new Breadcrumb(0, '< I miei pagamenti', '/iMieiPagamenti', null));
    } else {
      this.titolo = 'Nuovo pagamento';
      this.breadcrumbList.push(new Breadcrumb(0, 'Home', null, null));
      this.breadcrumbList.push(new Breadcrumb(1, 'Pagamenti', null, null));
      this.breadcrumbList.push(new Breadcrumb(1, 'Nuovo pagamento', null, null));
    }
  }

}
